import {
  Button,
  Card,
  Drawer,
  Input,
  Space,
  Statistic,
  Typography,
  message,
} from "antd";
import moment from "moment";
import { useCountry, useCurrency } from "../provider/courtryProvider";
import { CloseCircleFilled, CloseCircleOutlined } from "@ant-design/icons";
import useLocalStorage from "../hooks/useLocalstorage";
import { useMemo, useState } from "react";
import PaymentGateway from "../utils/paymentGateway";
import config from "../config";
import { useSelector } from "react-redux";

const CartCart = ({ item, setCartList = () => {} }) => {
  const country = useCountry();
  const handleRemove = (item) => {
    setCartList((prev) => {
      return prev.filter((i) => i.id !== item.id);
    });
  };
  return (
    <Card>
      <Typography.Text strong>{item.name}</Typography.Text>
      <div>
        <Typography.Text>
          {country.CurrencySymbol}{" "}
          {item.discountPrice &&
          moment(item.offerValidity, "DD MMM YYYY").isSameOrAfter(moment())
            ? item.discountPrice
            : item.price}{" "}
        </Typography.Text>
        {item.discountPrice &&
          moment(item.offerValidity, "DD MMM YYYY").isSameOrAfter(moment()) && (
            <Typography.Text>
              {country.CurrencySymbol} {item.price}{" "}
            </Typography.Text>
          )}
        <Typography.Text> / For {item.packageValidity} </Typography.Text>
      </div>
      <CloseCircleFilled
        style={{
          position: "absolute",
          right: 20,
          top: 20,
          fontSize: 16,
          cursor: "pointer",
        }}
        onClick={() => handleRemove(item)}
      />
    </Card>
  );
};

const Cart = ({ cartList = [], onClose, open, setCartList, ...restProps }) => {
  const currencyFormatter = useCurrency();
  const [promoCode, setPromoCode] = useState("");
  const shopDetails = useSelector((state) => state.shopDetails);
  const [coupon, setCoupon] = useState({
    isApplied: false,
    details: {},
    amount: 0,
  });
  const [totalAmount, setTotalAmount] = useState();
  const cartTotal = useMemo(() => {
    const result = cartList.reduce(
      (acc, cur) => parseFloat(cur.price) + acc,
      0
    );
    setTotalAmount(result);
    return result;
  }, [cartList]);
  const validatePromoCode = async (payload) => {
    try {
      const response = await fetch(
        `${config.newApiGateway}/coupon/create-Update-delete-get-coupon`,
        {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          method: "post",
          body: JSON.stringify({
            action: "validatePromoCode",
            promocode: payload,
          }),
        }
      );
      const data = await response.json();
      if (data.status === "SUCCESS") {
        let totalAmount = parseFloat(cartTotal);
        let discount = 0;
        if (data.data.discountType === "flat") {
          discount = parseFloat(data.data.discount);
        } else if (data.data.discountType === "percentage") {
          discount =
            (parseFloat(totalAmount) * parseFloat(data.data.discount)) / 100;
        }
        setCoupon({
          isApplied: true,
          details: data.data,
          amount: discount,
        });
        totalAmount -= discount;
        setTotalAmount(totalAmount);
        message.success(data.message);
      } else {
        message.error(data.message);
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setPromoCode("");
    }
  };
  const handleClaim = () => {
    if (!promoCode) {
      return message.error("Please enter the Promo code to Claim.");
    }
    if (coupon.isApplied && coupon.details.promocode === promoCode) {
      return message.info(`'${promoCode}' code is already applied`);
    }
    const payload = {
      promocode: promoCode,
    };
    validatePromoCode(payload);
  };
  const handlePromoCode = (e) => {
    const value = e.target.value;
    setPromoCode(value);
  };
  const payload = {
    shopId: shopDetails.shopId,
    type: "package",
    items: cartList,
    cartTotal: cartTotal,
    amountPaid: totalAmount,
    billingDate: moment().format("YYYY-MM-DD"),
    comboDiscount: 0,
    promocodeDiscount: coupon.isApplied ? coupon.amount : "",
    promocode: coupon.isApplied ? coupon.promocode : "",
  };
  return (
    <Drawer
      closable={false}
      placement="right"
      onClose={onClose}
      open={open}
      style={{
        background: "#FAFAFA",
      }}
      {...restProps}
    >
      <Typography.Title
        style={{
          textAlign: "center",
        }}
        level={4}
      >
        My Cart
      </Typography.Title>
      {cartList.map((i) => {
        return <CartCart setCartList={setCartList} item={i} />;
      })}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          background: "#FFFFFF",
          width: "100%",
          padding: "1rem",
          marginLeft: "-1.5rem",
        }}
      >
        {coupon.isApplied && (
          <Card
            style={{
              marginBottom: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.Text strong>
                Promo code({coupon.details.promocode})
              </Typography.Text>
              <CloseCircleOutlined size={24} />
            </div>
          </Card>
        )}
        <Input
          size="large"
          suffix={
            <Button type="primary" onClick={handleClaim} ghost size="large">
              Claim
            </Button>
          }
          style={{
            marginBottom: 10,
          }}
          value={promoCode}
          onChange={handlePromoCode}
          placeholder="Enter promo code...."
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography.Text
            strong
            style={{
              fontSize: 20,
            }}
          >
            {currencyFormatter(totalAmount)}
          </Typography.Text>
          <PaymentGateway
            amount={totalAmount}
            payload={payload}
            setCartList={setCartList}
            onClose={onClose}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default Cart;
